import { getQueryStringVariable } from '../data/utils/getQueryStringVariable';
import { appConfig } from "../appConfig";

var $ = window.$;

window.whenJqueryLoaded && window.whenJqueryLoaded(function () {
	$ = window.$;
});

function parseBoolean(value) {
    if (value != null && value.length > 0) {
        var currValue = value.toLowerCase().trim();
        if (currValue === 'true') {
            return true;
        }
    }
    return false;
}

export function loadedInIframe() {
    const isLoadedInIframe =   getQueryStringVariable('isLoadedInIframe') == 'true';
    try {
        return isLoadedInIframe || window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function topButtonScrollHandler() {
    var selector = $('#top-button');
    if ($(this).scrollTop() > 100) {
        //se non siamo in cima alla pagina
        //faccio apparire il box
        var isShown = parseBoolean(selector.attr('showed'));
        if (isShown === false) {
            selector.css("display", "flex").hide().fadeIn();
            selector.attr('showed', 'true');
        }
    } else {
      // altrimenti (il visitatore � in cima alla pagina scrollTop = 0)
      selector.fadeOut(10); // Il box scompare
      selector.attr('showed', 'false');
    }	
}

export function initTopButtonScrollHandler() {
    try {
        var topButtonEventEnabled = false;
        if (topButtonEventEnabled == false) {
            if (!loadedInIframe()) {
                // se non siamo in un iframe, quindi:
                // mobile, terminale, cassa self, prenotatore
                $(window).scroll(topButtonScrollHandler); // Allow scroll function
            
                $('#content').scroll(topButtonScrollHandler);
                
                $('#top-button').click(function() {
                    // Se clicco sul box torno su
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                });// Click
                
                topButtonEventEnabled = true;
            }
        }
    }catch(err) {
        console.log(err);
    }
    
}

export function selectSectionButton(section) {
    if((section||null)==null){
        return;
    }
    var btnId = "cg-"+section+"-button"; 
    
    const f_toggleSelected = function(currentSelected,newSelected){
        if(newSelected){
            if(currentSelected){
                currentSelected.classList.remove('cg-acceso');
            }
            newSelected.classList.add('cg-acceso');
        }
    }
 
 const currSelected = document.querySelector('.cg-menuTabMobile .cg-buttonMenuMobile.cg-acceso');
 const newSelected = document.querySelector('#'+btnId);	
 f_toggleSelected(currSelected,newSelected);
}

export function isOverlaySection(appContext, section,user){
        //return (appContext.showBetslip || (section==='betslip' && appContext.showBetslip === null) || 
        //appContext.showMyBets || (section==='mybets' && appContext.showMyBets === null) || 
    return ( ( ( appContext.showBetslip || (section==='betslip' && appContext.showBetslip === null) ) && (isBetslipPlayDirectRequest()?user && user.logged:true) ) || 
            ( appContext.isMyBetsShowable() && (appContext.showMyBets || (section==='mybets' && appContext.showMyBets === null) ) ) || 
            appContext.showCheckSystemBets || (section==='checkbetsystembets' && appContext.showCheckSystemBets === null )||
            appContext.showCheckBet || (section==='checkbet' && appContext.showCheckBet === null ||
            section ==='agenda-streaming')
            );
}

export function handleMenuVisibility(currentSection,appContext){
    if(currentSection !=='checkbet' && currentSection !=='checksystembets' && (currentSection !=='mybets' || !appContext.isMyBetsShowable())){
        if(appConfig && appConfig.MENU["show"]===true && !(appContext?.hideMenu) ){
            $("#xsport-menu").removeClass("d-none")
        }else{
            $("#xsport-menu").remove();
        }
    }
    
}

export function handleMenuLabels(labels){
    if(appConfig && appConfig.MENU["show"]===true){
        $(".cg-menuTabMobile .cg-buttons-row .cg-labelMenu").each(function(){
			const id = $(this).attr("id");
			if(((id || null) !== null) && ((labels[id] || null ) !== null) ){
				$(this).text(labels[id]);					
			}
		});
        const virtualButtonConfig = appConfig["VIRTUAL_BUTTON"];
        if(virtualButtonConfig && virtualButtonConfig.enabled){
        	$('#terminal-psv-button-label').text(virtualButtonConfig.label);
        	$('#terminal-psv-button').attr('onclick', 'location.href ="' + virtualButtonConfig.hrefPage + '"');
        	$('#terminal-psv-button').removeClass("d-none");
        }
        
        if(!appConfig.SHOP_MODE){
        	$('#cg-mybet-button').removeClass("d-none");
        }
    }
    
    
    $(".cg-menuTabMobile .cg-buttons-row").removeClass("d-none");
}

export function handleMenuItems() {
    appConfig.MENU["items"] && appConfig.MENU["items"].forEach(function(i){
        addMenuItem(i);
    });

     //handling menu items from JSON query string parameter
     try {
        const jsonQueryString = getQueryStringVariable('menuItems');
        const menuItems = JSON.parse(jsonQueryString);

        if (menuItems){
            if(menuItems.forEach){
                menuItems.forEach(function(i){
                    addMenuItem(i);
                });
            }else{
                addMenuItem(menuItems);
            }
        }
    }catch(err ){
        console.log(err);
    }
}

function addMenuItem(i){
    const btn = $("#xsport-menu .cg-buttons-row").children(".cg-buttonMenuMobile:first");
    const newBtn = btn.clone();
    const iconContainer = newBtn.find(".cg-iconContainer");
    newBtn.removeAttr("id");
    newBtn.removeAttr("onclick");

    iconContainer.children(".cg-labelMenu").text(i.label);
    i.attrs && Object.entries(i.attrs).forEach(([key, value]) =>{
        if(key == 'anchor'){
            const target = value['target']?'target="'+value['target']+'"':'';
            $(iconContainer).wrap('<a href="'+value['href']+'" '+target+'></a>');
        }else{
            newBtn.attr(key,value);
            if(key == 'id'){
                iconContainer.children(".cg-labelMenu").attr("id",value);
                iconContainer.children("i").addClass("cg-ico-"+value+"-xs");
            }
            
        }
    });

    iconContainer.children("i").removeClass("cg-ico-prematch-xs");
    $("#xsport-menu .cg-buttons-row").append(newBtn);
}

export function isBetslipPlayDirectRequest() {
    return getQueryStringVariable('playDirectly') != null;
}

export function vibrate() {
    try {
        navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    
        if (navigator.vibrate) {
            // vibration API supported
            navigator.vibrate([100]);
        } else {
            console.log('No vibration');
        }
    } catch(err) {
        console.log(err);
    }
}

export function setBetslipBottomBarHeight() {
    const menu = document.querySelector(".cg-menuTabMobile");
    if (menu != null) {
        const boundRectMenu = menu.getBoundingClientRect();
        const betslipBottomBar = document.querySelector(".betslip-bottom-bar");
        if (betslipBottomBar != null) {
            betslipBottomBar.style.bottom  = `${boundRectMenu.height}px`;
        }
    }
}

export function setTabLayerMobileHeight() {
    const boundRectMenu = document.querySelector(".cg-menuTabMobile")?.getBoundingClientRect();
    const boundRectHeader = document.querySelector(".cg-top-header")?document.querySelector(".cg-top-header").getBoundingClientRect():null;
    const boundRectBetslipBar = document.querySelector(".betslip-bottom-bar")?document.querySelector(".betslip-bottom-bar").getBoundingClientRect():null;
    const boundRectSmartbanner = document.querySelector(".smartbanner")?document.querySelector(".smartbanner").getBoundingClientRect():null;
    const height = boundRectMenu?.height+(boundRectBetslipBar?boundRectBetslipBar.height:0)+(boundRectHeader?boundRectHeader.height:0)+(boundRectSmartbanner?boundRectSmartbanner.height:0)+ "px";
    
    //TODO quando c'è div con id "cg-payment-method-section" escludere boundRectBetslipBar e boundRectSmartbanner dal calcolo dell'altezza

    if (document.querySelector(".cg-tabLayerMobile")) {
        document.querySelector(".cg-tabLayerMobile").style.height = `calc(100% - ${height})`;
    }
    
    setBetslipBottomBarHeight();
}
